// extracted by mini-css-extract-plugin
module.exports = {"recipientsTableLoader":"RecipientsTable_recipientsTableLoader__1LPVG","shimmer":"RecipientsTable_shimmer__3krJ5"};